import request from '@/utils/request'

export function shiptype (query) {
  return request({
    url: '/shipType/query',
    method: 'get',
    params: query
  })
}
export function shiplist (query) {
  return request({
    url: '/ship/query',
    method: 'get',
    params: query
  })
}
export function shipdetail (query) {
  return request({
    url: '/ship/get',
    method: 'get',
    params: query
  })
}

export function consult (data) {
  return request({
    url: 'consult/add',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/ship.js